import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { ItemId, Project, DuplicateProject } from '../types/items';
import { transformList } from './transformer';

class ProjectService {
  private route = apis.project;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<Project>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<Project>(`${this.route.list}/${id}`);

  template = () => this.api.get<Project>(`${this.route.list}/new`);

  save = (id: ItemId, { ref, permissions, ...project }: Project) => this.api.put(`${this.route.list}/${id}`, project);

  create = ({
    id, ref, permissions, ...project
  }: Project) => this.api.post<Project>(this.route.list, project);

  delete = (id: ItemId) => this.api.delete(`${this.route.list}/${id}`);

  duplicate = (duplicateProject: DuplicateProject) => this.api
    .post<DuplicateProject>(`${this.route.list}/${duplicateProject.project_id}/clone`, duplicateProject);
}

export default new ProjectService(apiService);
